export default __webpack_public_path__ + "static/logo-b4c3ac26345b6aae5eec3b4aba76e094.svg";